import { render, staticRenderFns } from "./NotificationsPermissionModal.vue?vue&type=template&id=41634eab&scoped=true&"
import script from "./NotificationsPermissionModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsPermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41634eab",
  null
  
)

export default component.exports